import { render, staticRenderFns } from "./SelectAddress.vue?vue&type=template&id=30b965d3&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./SelectAddress.vue?vue&type=script&lang=ts"
export * from "./SelectAddress.vue?vue&type=script&lang=ts"
import style0 from "./SelectAddress.vue?vue&type=style&index=0&id=30b965d3&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports